import React from 'react';
import { ReactComponent as Done } from '@/assets/image/done.svg';

interface ChipProps {
  selected?: boolean;
  // eslint-disable-next-line no-unused-vars
  onClick?: (e: React.MouseEvent<HTMLDivElement, MouseEvent>) => void;
  label: string;
  disabled?: boolean;
}

const Chip: React.FC<ChipProps> = ({ selected, onClick, label, disabled = false }) => {
  const handleClick = (e: React.MouseEvent<HTMLDivElement, MouseEvent>) => {
    if (disabled) return;
    if (onClick) {
      onClick(e);
    }
  };

  const handleKeyDown = (e: React.KeyboardEvent<HTMLDivElement>) => {
    if (disabled) return;
    if (e.key === 'Enter' || e.key === ' ') {
      e.preventDefault();
      if (onClick) {
        onClick(e as any);
      }
    }
  };

  return (
    <div
      onClick={handleClick}
      onKeyDown={handleKeyDown}
      role="button"
      tabIndex={disabled ? -1 : 0}
      className={`flex h-fit w-fit cursor-pointer items-center justify-center gap-2 rounded-full px-4 py-2 text-sm font-medium transition-all duration-200 ease-in-out ${
        disabled 
          ? 'bg-gray-100 text-gray-400 cursor-not-allowed border border-transparent' 
          : selected 
            ? 'bg-[#F4F7FE] text-[#039BE5] border border-[#039BE5]' 
            : 'bg-white text-black border border-[#D7D7D7] hover:bg-gray-50'
      }`}
      style={selected ? { boxShadow: '0 4px 6px -1px rgba(0, 0, 0, 0.1), 0 2px 4px -1px rgba(0, 0, 0, 0.06)' } : {}}
    >
      <span>{label}</span>
      <div className="flex items-center justify-center" style={{ width: '16px', height: '16px' }}>
        {selected && <Done />}
      </div>
    </div>
  );
};

export default Chip;